import { TherapistAction } from 'src/redux/actions/constant';

const intialState: any = {
  response: null,
  isTherapistAssignTask: false,
  data: [],
  selectedTasks: [],
  loading: false,
  isError: false,
};

export const therapistAssignTaskReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.THERAPIST_TASK_ASSIGN_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isTherapistAssignTask: true,
        data: action.payload.data,
        selectedTasks: action.toPick ? action.selectedTasks : state.selectedTasks,
        loading: false,
        isError: false,
      };
    }
    case TherapistAction.THERAPIST_TASK_ASSIGN_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isTherapistAssignTask: false,
        loading: false,
        isError: true,
      };
    }
    case TherapistAction.THERAPIST_TASK_ASSIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case TherapistAction.THERAPIST_TASK_ASSIGN_RESET:
      return {
        ...state,
        response: null,
      };

    default:
      return state;
  }
};
